import { PAPEvent } from "@mirage/analytics/events/base/event";
import { ActionSurfaceComponent } from "@mirage/analytics/events/enums/action_surface_component";
import { PAP_Click_ChatSuggestion } from "@mirage/analytics/events/types/click_chat_suggestion";
import { PAP_Send_ComposePrompt } from "@mirage/analytics/events/types/send_compose_prompt";
import { SuggestionTile } from "@mirage/mosaics/SuggestionTile/SuggestionTile";
import useSearchQueryId from "@mirage/shared/hooks/useSearchQueryId";
import { memo } from "react";
import styles from "./SuggestedQueryChips.module.css";
interface SuggestedQueryChipsProps {
  suggestedQueries: string[];
  onSubmit: (query: string) => void;
  withPadding?: boolean;
  logComposeEvent: (
    event: PAPEvent,
    overrides?: { actionSurfaceComponent?: ActionSurfaceComponent },
  ) => void;
  conversationId?: string;
  assistRequestId?: string;
  searchSessionId?: string;
}
export const SuggestedQueryChips = memo(
  ({
    suggestedQueries,
    withPadding = false,
    onSubmit,
    logComposeEvent,
    conversationId,
    assistRequestId,
    searchSessionId,
  }: SuggestedQueryChipsProps) => {
    const { searchQueryUuid } = useSearchQueryId();
    return (
      <div className={styles.suggestedQueryChips}>
        {suggestedQueries.map((query, i) => (
          <SuggestionTile
            key={i}
            text={query}
            size="small"
            onClick={() => {
              logComposeEvent(
                PAP_Send_ComposePrompt({
                  actionSurfaceComponent: "prompt_suggestion",
                  queryString: query,
                  queryLength: query.length,
                  conversationId,
                  promptType: "chat_suggestion",
                  assistRequestId,
                  searchQueryUuid,
                  searchSessionId,
                }),
              );

              logComposeEvent(
                PAP_Click_ChatSuggestion({
                  actionSurfaceComponent: "prompt_suggestion",
                  generatedQueryString: query,
                  promptType: "chat_suggestion",
                  conversationId,
                  assistRequestId,
                  searchQueryUuid,
                  searchSessionId,
                }),
              );
              onSubmit(query);
            }}
            withPadding={withPadding}
            conversationId={conversationId}
            assistRequestId={assistRequestId}
            searchSessionId={searchSessionId}
            withNoBackground
          />
        ))}
      </div>
    );
  },
);
SuggestedQueryChips.displayName = "SuggestedQueryChips";
